module.exports = __webpack_public_path__ + "media/genialharas.f942f3a2.mp3";